import styled, { css } from 'styled-components';
import { always, cond, propEq } from 'ramda';
import Markdown from 'react-markdown';

import { ContentContainer } from '../layout/layout.styles';
import { media } from '../../utils/media';

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 1em;
  letter-spacing: 0.9px;
  margin-left: 45px;
  text-transform: uppercase;
  padding: 16px 0 26px;
  margin-bottom: 0;

  ${media.desktop`
    margin-left: 0;
  `}
`;

export const NumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0 0 16px;
`

export const Number = styled.h2`
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 68px;
  line-height: 72px;
  letter-spacing: -1px;
  padding: 0;
  margin: 0;
`

export const Character = styled.h3`
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 56px;
  display: flex;
  align-items: flex-end;
  margin: 0;
  padding-left: 2px;
`

export const MarkdownContent = styled(Markdown)`
  h2 {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 120px;
    line-height: 120px;
    letter-spacing: -1.55714px;
    margin: 0 0 13px 0;
    padding: 0 30px 30px;
  }
  h3 {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 21px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    padding: 10px 10px 12px;
    margin: 0;
  }
  h4 {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 27px;
    color: #000000;
    padding: 0  10px 10px;
    margin: 0;
  }
  p {
    font-family: 'IBM Plex Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 21px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    padding: 0;
    margin: 0;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

export const CardContent = styled.div`
`;

export const Card = styled.div`
  padding: 10px;

  ${media.bigMobile`
    padding: 10px 15px;
  `}

  ${media.desktopWide`
    padding: 24px 30px;
  `}

  :last-child {
    margin-right: 0;
  }
`;

export const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  grid-gap: 10px;
  margin: 0 12px 72px 12px;
  

  ${media.tablet`
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin: 0 0 72px 0;
  `}

  ${media.desktopWide`
    max-width: 100%;
    grid-gap: 40px 30px;
    margin: 0 0 20px;
  `}

  @media print {
    page-break-inside: avoid;
  }
`;

const colorsStyles = ({ theme }) => css`
  color: ${theme.color};
  ${Card} {
    background-color: ${theme.background};
  }

  ${Title} {
    color: ${theme.color};
  }
`;

export const Container = styled(ContentContainer)`
  ${colorsStyles};
  padding-left: 0;
  width: 100%;

  ${media.tablet`
    width: 640px;
  `};

  ${media.desktop`
    padding-left: 290px;
    width: 800px;
  `};

  ${media.desktopWide`;
    padding-left: 340px;
    width: 1000px;
    padding-bottom: 12px;
  `};
`;
